function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import regeneratorRuntime from "regenerator-runtime";
import React, { useEffect, useState } from "react";
import Progress from "../progress";
import request from "../../utils/request";
import { context, updateContextState, useWrContext } from "../wr-context";
import { ErrorText } from "../text";
import safeJsonParse from "../../utils/safe-json-parse";
import propTypes from "prop-types";
import i18n from "../../utils/i18n";
var getExternalUser = function(token) {
    var decodedToken = safeJsonParse(window.atob(token.split(".")[1]));
    var id = decodedToken.id, rest = _objectWithoutProperties(decodedToken, [
        "id"
    ]);
    return rest;
};
var extractRouteParams = function() {
    var searchParams = new URLSearchParams(window.location.search);
    var token = searchParams.get("token");
    var origin = searchParams.get("origin");
    return {
        token: token,
        origin: origin
    };
};
var TokenHandler = function(param) {
    var setIsResolved = param.setIsResolved, setError = param.setError;
    var newWindowFlow = Boolean(context.constants.sso.newWindowFlow);
    useEffect(function() {
        var onAuthResolved = context.constants.sso.onAuthResolved;
        var ref = extractRouteParams(), token = ref.token, origin = ref.origin;
        if (!token || !origin) {
            setError("Token authentication failed, please close this tab and try again later");
            return;
        }
        var user = getExternalUser(token);
        if (newWindowFlow) {
            window.opener.postMessage({
                token: token,
                user: user,
                messageType: "wrAuthDone"
            }, origin);
            window.setTimeout(function() {
                window.close();
            }, 300);
        } else {
            context.persistentStorage.set(context.constants.sso.tokenStorageKey, token);
            if (typeof onAuthResolved === "function") {
                onAuthResolved({
                    authorization: token,
                    user: user
                });
            }
            updateContextState(function(state) {
                state.authorization = token;
                state.isLoggedIn = true;
                state.user = user;
            });
            // Make sure internal history is synced with browser history
            context.history.replace(context.getRoutePath("index"));
            // Clean up browser URL without redirecting
            window.history.replaceState(null, "", context.getRoutePath("index"));
            setIsResolved(true);
        }
    }, []);
    return /*#__PURE__*/ React.createElement(Progress, null);
};
TokenHandler.propTypes = {
    setIsResolved: propTypes.func.isRequired,
    setError: propTypes.func.isRequired
};
var AuthResolver = function(param) {
    var children = param.children;
    var ref = useWrContext(), isLoginResolving = ref.state.isLoginResolving;
    var ref1 = extractRouteParams(), _token = ref1.token;
    var ref2 = _slicedToArray(useState(false), 2), isResolved = ref2[0], setIsResolved = ref2[1];
    var ref3 = _slicedToArray(useState(""), 2), error = ref3[0], setError = ref3[1];
    var isTokenRoute = Boolean(_token && !isLoginResolving);
    var ssoHost = context.constants.sso.host || context.constants.appHost;
    var redirectUrl = "".concat(ssoHost, "/api/v1/sso/init/").concat(context.constants.token);
    var newWindowFlow = Boolean(context.constants.sso.newWindowFlow);
    var onAuthResolved = context.constants.sso.onAuthResolved;
    useEffect(function() {
        _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            var isLoggedIn;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!isLoginResolving) {
                            _ctx.next = 11;
                            break;
                        }
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return request({
                            url: "".concat(ssoHost, "/api/v1/sso/is-authenticated"),
                            method: "GET",
                            headers: {
                                authorization: context.persistentStorage.get(context.constants.sso.tokenStorageKey)
                            }
                        }).then(function(v) {
                            return v.data.isAuthenticated;
                        });
                    case 4:
                        isLoggedIn = _ctx.sent;
                        if (isLoggedIn) {
                            updateContextState(function(state) {
                                state.isLoggedIn = true;
                                state.isLoginResolving = false;
                            });
                        } else {
                            context.persistentStorage.remove(context.constants.sso.tokenStorageKey);
                            updateContextState(function(state) {
                                state.isLoginResolving = false;
                                state.isLoggedIn = false;
                            });
                        }
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](1);
                        context.persistentStorage.remove(context.constants.sso.tokenStorageKey);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    8
                ]
            ]);
        }))();
    }, []);
    useEffect(function() {
        if (isResolved || isLoginResolving) {
            return;
        }
        var messageHandler = function(e) {
            var ref;
            if (e.data && ((ref = e.data) === null || ref === void 0 ? void 0 : ref.messageType) === "wrAuthDone") {
                var token = e.data.token;
                context.persistentStorage.set(context.constants.sso.tokenStorageKey, token);
                var user = getExternalUser(token);
                if (typeof onAuthResolved === "function") {
                    onAuthResolved({
                        authorization: token,
                        user: user
                    });
                }
                updateContextState(function(state) {
                    state.authorization = token;
                    state.isLoggedIn = true;
                    state.user = user;
                });
                setIsResolved(true);
            }
        };
        if (!isTokenRoute) {
            if (newWindowFlow) {
                var windowFeatures = "toolbar=no, menubar=no, width=600, height=700, top=100, left=100";
                window.addEventListener("message", messageHandler);
                var newWindow = window.open(redirectUrl, "Sign In", windowFeatures);
                if (!newWindow) {
                    setError(/*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("p", null, i18n("sso.popupBlockedMessage"))));
                }
            } else {
                window.location.href = redirectUrl;
            }
        }
        return function() {
            window.removeEventListener("message", messageHandler);
        };
    }, [
        isTokenRoute,
        isResolved,
        isLoginResolving
    ]);
    return error ? /*#__PURE__*/ React.createElement(ErrorText, null, error) : isResolved ? children : isTokenRoute ? /*#__PURE__*/ React.createElement(TokenHandler, {
        setIsResolved: setIsResolved,
        setError: setError
    }) : /*#__PURE__*/ React.createElement(Progress, null);
};
AuthResolver.propTypes = {
    children: propTypes.any
};
export default AuthResolver;
